import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const APIFailureMessage = () => /*#__PURE__*/_jsx(ErrorMessage, {
  type: "badRequest",
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "error.APIFailure"
    })
  })
});
export default APIFailureMessage;